/* KOTH scroll reveal. Skipped when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = (!reduce && 'IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function scan(root) {
    (root || document).querySelectorAll('.koth-reveal:not(.is-in)').forEach(function (el) {
      io ? io.observe(el) : el.classList.add('is-in');
    });
  }
  document.documentElement.classList.add('koth-js');
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* KOTH quiz */
(function () {
  function init(root) {
    root.querySelectorAll('[data-koth-quiz]').forEach(function (q) {
      var ans = '', steps = q.querySelectorAll('.koth-quiz__step'), dots = q.querySelector('.koth-quiz__dots');
      function show(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
        dots.style.display = i < 3 ? '' : 'none';
        dots.innerHTML = [0,1,2].map(function (j) { return j === i ? '<b>\u25CF</b>' : '\u25CF'; }).join(' ');
      }
      q.addEventListener('click', function (e) {
        var o = e.target.closest('.koth-quiz__opt');
        if (o) {
          ans += o.dataset.v; show(ans.length);
          if (ans.length === 3) {
            var r = q.querySelector('[data-result="' + ans + '"]') || q.querySelector('[data-result]');
            if (r) r.classList.add('is-on');
          }
        }
        if (e.target.closest('[data-quiz-reset]')) {
          ans = ''; q.querySelectorAll('.koth-quiz__result').forEach(function (r) { r.classList.remove('is-on'); }); show(0);
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* KOTH quick-add drawer (AJAX cart). Adds a "+" to Dawn product cards; any [data-koth-qa="handle"] also opens it. */
(function () {
  var ASSURE = 'Free US shipping \u00B7 Easy returns';
  var d = document.createElement('div');
  d.className = 'koth-qa'; d.setAttribute('aria-hidden', 'true');
  d.innerHTML = '<div class="koth-qa__scrim" data-close></div><aside class="koth-qa__panel" role="dialog" aria-modal="true" aria-label="Quick add">' +
    '<button class="koth-qa__close" data-close aria-label="Close">\u00D7</button><div class="koth-qa__content"></div></aside>';
  document.body.appendChild(d);
  var content = d.querySelector('.koth-qa__content'), last;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { var t = document.createElement('div'); t.textContent = s || ''; return t.innerHTML; }
  function summary(html) { var t = document.createElement('div'); t.innerHTML = html || ''; var p = t.querySelector('p'); var s = (p || t).textContent.trim(); return s.length > 180 ? s.slice(0, 177) + '\u2026' : s; }
  function close() { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); if (last) last.focus(); }
  function open(handle, btn) {
    last = btn;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
      var sel = p.variants.length > 1 ? '<select aria-label="Option">' + p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + ' \u00B7 ' + money(v.price) + '</option>'; }).join('') + '</select>' : '';
      content.innerHTML = (img ? '<img class="koth-qa__img" src="' + img + '" alt="' + esc(p.title) + '">' : '') +
        '<div class="koth-qa__body"><h2 class="koth-qa__title">' + esc(p.title) + '</h2><p class="koth-qa__price">' + money(p.price) + '</p>' +
        '<p class="koth-qa__sum">' + esc(summary(p.description)) + '</p>' + sel +
        '<button class="koth-btn koth-qa__add"' + (avail.length ? '' : ' disabled') + '>' + (avail.length ? 'Add to cart' : 'Sold out') + '</button>' +
        '<p class="koth-qa__assure">' + ASSURE + '</p><a class="koth-qa__link" href="' + root + 'products/' + handle + '">View full details</a></div>';
      var s = content.querySelector('select'); if (s && avail[0]) s.value = avail[0].id;
      content.querySelector('.koth-qa__add').addEventListener('click', function (e) {
        var b = e.currentTarget, id = s ? s.value : (avail[0] && avail[0].id);
        b.disabled = true; b.textContent = 'Adding\u2026';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); }).then(function (r) { return r.json(); })
          .then(function (c) {
            b.textContent = 'Added'; document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (x) { x.textContent = c.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () { close(); window.location.href = root + 'cart'; }, 600);
          }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
      });
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.querySelector('.koth-qa__close').focus();
    });
  }
  d.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('is-open')) close(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-koth-qa]'); if (!t) return;
    e.preventDefault(); e.stopPropagation(); open(t.dataset.kothQa, t);
  }, true);
  function addTriggers(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.querySelector('.koth-qa-trigger')) return;
      var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      var b = document.createElement('button'); b.type = 'button'; b.className = 'koth-qa-trigger';
      b.setAttribute('aria-label', 'Quick add'); b.dataset.kothQa = h; b.textContent = '+'; c.appendChild(b);
    });
  }
  addTriggers();
  document.addEventListener('shopify:section:load', function (e) { addTriggers(e.target); });
})();